/* unplugin-vue-components disabled */import { render } from "./PositionDetail.vue?vue&type=template&id=a8eb9a02"
import script from "./PositionDetail.vue?vue&type=script&lang=js"
export * from "./PositionDetail.vue?vue&type=script&lang=js"

import "./PositionDetail.vue?vue&type=style&index=0&id=a8eb9a02&lang=scss"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__